import { render, staticRenderFns } from "./AnimationCanvas.vue?vue&type=template&id=5b73f060&scoped=true&"
import script from "./AnimationCanvas.vue?vue&type=script&lang=js&"
export * from "./AnimationCanvas.vue?vue&type=script&lang=js&"
import style0 from "./AnimationCanvas.vue?vue&type=style&index=0&id=5b73f060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b73f060",
  null
  
)

export default component.exports